import LightTooltip from 'components/common/LightTooltip';

const formatExpiryPeriod = (hours: number): string => {
    if (hours % 168 === 0) {
        const weeks = hours / 168;
        return `${weeks} ${weeks === 1 ? 'Week' : 'Weeks'}`;
    }

    if (hours % 24 === 0) {
        const days = hours / 24;
        return `${days} ${days === 1 ? 'Day' : 'Days'}`;
    }

    return `${hours} ${hours === 1 ? 'Hour' : 'Hours'}`;
};

interface Props {
    documentName: string;
    currentGroup: {
        name: string;
        groupOnlyExpiryPeriod: number;
    };
}

const GroupOnlyTemporaryLabelRenderer = ({
    documentName,
    currentGroup,
}: Props) => {
    const { name, groupOnlyExpiryPeriod } = currentGroup;

    const expiryLabel = formatExpiryPeriod(groupOnlyExpiryPeriod);
    const label = `${name} - Group Only (${expiryLabel})`;
    const tooltip = `This ${documentName} will become visible to all groups ${expiryLabel.toLowerCase()} after it is created`;

    return (
        <LightTooltip title={tooltip} placement="right" arrow>
            <div>{label}</div>
        </LightTooltip>
    );
};

export default GroupOnlyTemporaryLabelRenderer;
